// Typelizer digest 81210dbc2c1f4518c6e1a9c433167645
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** PATCH /field_groups/:field_group_id/days/:date */
  update: (
    params: { fieldGroupId: string | number; date: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/field_groups/:field_group_id/days/:date', params, options),
    method: 'patch',
  }),
}
